import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------
const base_url = '/v1/joblistsweb';

const initialState = {
  isLoading: false,
  error: null,
  joblists: [],
  joblist: null,
};

const slice = createSlice({
  name: 'joblists',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ALL
    getJList(state, action) {
      state.isLoading = false;
      state.joblists = action.payload;
    },

    // GET ONE
    getOneJList(state, action) {
      state.isLoading = false;
      state.joblist = action.payload;
    },

    // CREATE
    createJList(state, action) {
      const newdata = action.payload;
      state.isLoading = false;
      state.joblists = [...state.joblists, newdata];
    },

    // UPDATE
    updateJList(state, action) {
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function get() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(base_url);
      dispatch(slice.actions.getJList(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/${id}/joblist`);
      dispatch(slice.actions.getOneJList(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getByJobCode(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${base_url}/getbyjobcode?job_code=${id}`);
      dispatch(slice.actions.getOneJList(response.data.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function create(newData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${base_url}`, newData);
      dispatch(slice.actions.createJList(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function update(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`${base_url}`, data);
      dispatch(slice.actions.updateJList(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`${base_url}?id=${id}`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
